export const faqs = [
  {
    q: 'Est-ce adapté à tous les niveaux\u00a0?',
    a: 'Oui. Chaque séance propose une Version A pour les débutants, une Version B pour les intermédiaires et une Version C pour les avancés. Vous pouvez donner le même cours à un groupe mixte sans aucun problème.',
  },
  {
    q: 'Combien vais-je payer exactement\u00a0?',
    a: '19\u00a0€, en paiement unique. Le montant final s’affiche clairement avant que vous validiez votre paiement\u00a0: aucune surprise, aucun abonnement, aucun frais supplémentaire inattendu.',
  },
  {
    q: 'Comment vais-je recevoir le contenu\u00a0?',
    a: 'Accès immédiat en 5 minutes. Juste après le paiement, vous recevez un e-mail avec votre lien personnel. Vous téléchargez les 6 Tomes en PDF — les fichiers sont à vous POUR TOUJOURS. Imprimez-les ou utilisez-les directement depuis votre téléphone, votre tablette ou votre ordinateur.',
  },
  {
    q: 'Faut-il du matériel spécial\u00a0?',
    a: 'NON — Du matériel de base suffit. Les séances utilisent\u00a0: barres, haltères, kettlebells, box, TRX et tapis. Si votre salle a l’essentiel, C’EST BON.',
  },
  {
    q: 'Est-ce que ça fonctionne si je suis coach en salle et pas professeur d’EPS\u00a0?',
    a: 'OUI — 70\u00a0% de nos clients sont coachs en salle de sport. FITNESS FONCTIONNEL 365 convient aux professeurs, coachs en salle, coachs de CrossFit, coachs sportifs et préparateurs physiques.',
  },
  {
    q: 'La garantie est-elle réelle\u00a0?',
    a: '100\u00a0% réelle — Sans formulaire, sans complication. Si vous achetez aujourd’hui et que ça ne vous plaît pas dans les 7 jours, envoyez-nous un e-mail et on vous rembourse. Sans poser de questions. Moins de 2\u00a0% des clients demandent un remboursement.',
  },
  {
    q: 'Je débute\u00a0: faut-il des connaissances en programmation\u00a0?',
    a: 'NON. Pas besoin de maîtriser la périodisation ni la théorie avancée. Chaque séance EST DÉJÀ construite avec son objectif, ses exercices et ses séries. Vous ouvrez, vous lisez, vous coachez. Ça marche pour les nouveaux coachs comme pour les pros\u00a0: 40\u00a0% de nos clients débutent dans le métier.',
  },
  {
    q: 'Puis-je l’utiliser avec plusieurs groupes\u00a0?',
    a: 'OUI — Utilisation illimitée avec tous vos groupes. Un seul paiement = un accès à vie. 1 groupe, 5 groupes ou 20 groupes\u00a0: aucune restriction.',
  },
]
